module.exports = __webpack_public_path__ + "static/media/not_found_desktop.8afa4b7f.svg";